import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Route } from '@angular/router';
import { PageNotFoundComponent } from './pages/page-not-found/containers/page-not-found.component';
import { PrequalGuard } from './pages/prequalifying-step-forms/containers/prequalifying-step-forms/prequal.guard';
import { OfferGuard } from './shared/guards/offer.guard';

const routes: Route[] = [
  {
    path: 'auto-loans/prequalify',
    pathMatch: 'full',
    loadChildren: './pages/prequalifying-step-forms/prequalifying-step-forms.module#PrequalifyingStepFormsModule',
    canActivate: [PrequalGuard]
  },
  {
    path: 'auto-loans/prequalify/:media',
    loadChildren: './pages/prequalifying-step-forms/prequalifying-step-forms.module#PrequalifyingStepFormsModule'
  },
  {
    path: 'auto-loans/offer',
    loadChildren: './pages/offer/offer.module#OfferModule',
    canActivate: [OfferGuard]
  },
  {
    path: 'auto-loans/summary',
    loadChildren: './pages/summary/summary.module#SummaryModule'
  },
  {
    path: 'customer-account',
    loadChildren: './pages/customer-account/customer-account.module#CustomerAccountModule'
  },
  {
    path: 'cars-online',
    loadChildren: './pages/vehicle-listing/vehicle-listing.module#VehicleListingModule'
  },
  {
    path: 'cars-online/page/:id',
    loadChildren: './pages/vehicle-listing/vehicle-listing.module#VehicleListingModule'
  },
  {
    path: 'cars-online/:slug',
    loadChildren: './pages/vehicle-details/vehicle-details.module#VehicleDetailsModule'
  },
  {
    path: 'cars-online/:vehicleAddress/prequalify',
    pathMatch: 'full',
    loadChildren: './pages/prequalifying-step-forms/prequalifying-step-forms.module#PrequalifyingStepFormsModule',
    canActivate: [PrequalGuard]
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app.routing.module.ts